<template>
  <select
    :id="id"
    :data-test-id="testId"
    class="form-select"
    :title="$t('selectPreset')"
    :disabled="!presets.length || isLoading"
    v-model="selectedPresetId"
  >
    <option v-for="preset in presets" :key="preset.id" :value="preset.id">
      {{ preset.name }}
    </option>
  </select>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import type { SettingPreset } from '../../../data-access';

export default defineComponent({
  name: 'PresetSelect',
  props: {
    id: {
      type: String,
      default: undefined
    },
    testId: {
      type: String,
      default: 'preset-selector'
    }
  },
  computed: {
    presets(): SettingPreset[] {
      return this.$store.state.epoch.settings.presets;
    },
    isLoading(): boolean {
      return this.$store.state.epoch.settings.isLoading;
    },
    selectedPresetId: {
      get(): number {
        return this.$store.state.epoch.settings.selectedPresetId;
      },
      set(presetId: number) {
        this.$store.commit('epoch/setSelectedPreset', presetId);
        this.$store.dispatch('epoch/updatePresetSettings', {
          selectedPresetId: presetId,
          isSelectedPresetChange: true
        });
      }
    }
  }
});
</script>
